/* eslint-disable */
// @ts-nocheck
/*
* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
*/

export enum OnlineTimeToLiveInterval {
  DAYS = "DAYS",
  MONTHS = "MONTHS",
  HOURS = "HOURS",
  MINUTES = "MINUTES",
}

export enum OfflineTimeToLiveInterval {
  YEARS = "YEARS",
  DAYS = "DAYS",
  MONTHS = "MONTHS",
  HOURS = "HOURS",
}

export type Online = {
}

export type Offline = {
}

export type TimeToLive = {
  ttlOffline?: number
  ttlOfflineInterval?: OfflineTimeToLiveInterval
  ttlOnline?: number
  ttlOnlineInterval?: OnlineTimeToLiveInterval
}